import { tracking } from '@iwoca/frontend-tracking-library';
import classnames from 'classnames';

import styles from './DefaultItems.module.css';
import { buildQueryString } from '../../../Buyer/utils/queryParams';
import { useUserGroups } from '../../../hooks/useUserGroups';
import { ReactComponent as SwitchIcon } from '../../svg/SwitchIcon.svg';
import { Menu } from '../NavBarBase/Menu/Menu';
import { TelephoneNavItem } from '../NavBarBase/TelephoneNavItem/TelephoneNavItem';
import { loansDashboardItem } from '../SellerNavBar/links';

export function DefaultNavItems({ className }: { className?: string }) {
  return (
    <div className={className} data-testid="navBarRightPane">
      <div className={classnames(styles.switchDashboards, styles.navBarItem)}>
        <LoansDashboardButton />
      </div>
      <div className={classnames(styles.desktopOnly, styles.navBarItem)}>
        <TelephoneNavItem />
      </div>
      <div className={styles.navBarItem}>
        <div className={styles.navBarAnchor}>
          <Menu />
        </div>
      </div>
    </div>
  );
}

const LoansDashboardButton = () => {
  const { isLoading, isStaff, isOwner } = useUserGroups();

  if (isLoading) return null;
  if (!(isStaff || isOwner)) return null;

  return (
    <a
      className={styles.navBarAnchor}
      data-testid="loansDashboard"
      href={`${loansDashboardItem.link}${buildQueryString()}`}
      data-ga-id="navbar__switch"
      onClick={() => tracking.ampli.switchedToCoreBusinessDashboard()}
    >
      {loansDashboardItem.label}
      <SwitchIcon
        className={classnames(styles.switchIcon, styles.navBarAnchorIcon)}
      />
    </a>
  );
};
